<template>
  <div id="SignUpFor">
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="text-left">
          <van-row class="m-2 pl-4 pt-4 pr-4">
            <van-col span="3">
              <img src="../assets/logo.png" width="30px" height="30px" />
            </van-col>
            <van-col span="21">
              <div class="demo-content">
                <h3>报名信息</h3>
                <p class="text-desc">{{SignUpForData.ScrollMsg}}</p>
              </div>
            </van-col>
          </van-row>
          <!-- 数据分类 -->
          <div class="m-2">
            <van-tabs v-model="active">
              <van-tab title="报名信息">
                <!-- 报名信息 -->
                <div class="m-2">
                  <van-grid :column-num="2" :border="false">
                    <van-grid-item v-if="SignUpForData.ExamData">
                      <template slot="text">
                        <div class="text-title text-bold">{{SignUpForData.ExamData.StuNum}}</div>
                        <p class="text-desc">考生</p>
                      </template>
                    </van-grid-item>
                    <van-grid-item v-if="SignUpForData.ExamData">
                      <template slot="text">
                        <div class="text-title text-bold">{{SignUpForData.ExamData.JobNum}}</div>
                        <p class="text-desc">职位</p>
                      </template>
                    </van-grid-item>
                    <van-grid-item v-if="SignUpForData.ExamData">
                      <template slot="text">
                        <div class="text-title text-bold">{{SignUpForData.ExamData.RecruitNum}}</div>
                        <p class="text-desc">计划招录</p>
                      </template>
                    </van-grid-item>
                    <van-grid-item v-if="SignUpForData.ExamData">
                      <template slot="text">
                        <div
                          class="text-title text-bold"
                        >{{SignUpForData.ExamData.AdmissionPercent}}</div>
                        <p class="text-desc">招录比</p>
                      </template>
                    </van-grid-item>
                  </van-grid>
                </div>
              </van-tab>
              <van-tab title="考生数据">
                <!-- 考生数据 -->
                <div class="m-2">
                  <!-- 考生性别 -->
                  <van-cell
                    v-if="SignUpForData.StudentSex"
                    title="考生性别"
                    title-class="text-bold"
                    size="large"
                    icon="manager-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentSex"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 考生学历 -->
                  <van-cell
                    v-if="SignUpForData.StudentExperience"
                    title="考生学历"
                    title-class="text-bold"
                    size="large"
                    icon="newspaper-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentExperience"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 考生年龄 -->
                  <van-cell
                    v-if="SignUpForData.StudentAge"
                    title="考生年龄"
                    title-class="text-bold"
                    size="large"
                    icon="descending"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentAge"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 考生身份 -->
                  <van-cell
                    v-if="SignUpForData.StudentIdentity"
                    title="考生身份"
                    title-class="text-bold"
                    size="large"
                    icon="newspaper-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentIdentity"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 政治面貌 -->
                  <van-cell
                    v-if="SignUpForData.StudentPolitics"
                    title="政治面貌"
                    title-class="text-bold"
                    size="large"
                    icon="coupon"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentPolitics"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 考生籍贯 -->
                  <van-cell
                    v-if="SignUpForData.StudentNative"
                    title="考生籍贯"
                    title-class="text-bold"
                    size="large"
                    icon="location-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentNative"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 毕业院校 -->
                  <van-cell
                    v-if="SignUpForData.KeyAddrStatis"
                    title="毕业院校"
                    title-class="text-bold"
                    size="large"
                    icon="newspaper-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.KeyAddrStatis"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                  <!-- 所学专业 -->
                  <van-cell
                    v-if="SignUpForData.StudentSXZY"
                    title="所学专业"
                    title-class="text-bold"
                    size="large"
                    icon="newspaper-o"
                  >
                    <template slot="label">
                      <van-row
                        v-for="(item,index) in SignUpForData.StudentSXZY"
                        :key="index"
                        class="p-1"
                      >
                        <van-col span="12" class="text-overflow">{{item.FieldName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StuPercent}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                </div>
              </van-tab>
              <van-tab title="考区数据">
                <!-- 考区数据 -->
                <div class="m-2">
                  <van-cell
                    v-if="SignUpForData.AreaSignUp"
                    title="考区报名数据"
                    title-class="text-bold"
                    size="large"
                    icon="newspaper-o"
                  >
                    <template slot="label">
                      <van-row class="p-2">
                        <van-col span="6" class="text-overflow">地区</van-col>
                        <van-col span="6" class="text-right">报名人数</van-col>
                        <van-col span="6" class="text-right">计划招录</van-col>
                        <van-col span="6" class="text-right">招录比</van-col>
                      </van-row>
                      <van-row
                        v-for="(item,index) in SignUpForData.AreaSignUp"
                        :key="index"
                        class="p-2"
                      >
                        <van-col span="6" class="text-overflow">{{item.AreaName}}</van-col>
                        <van-col span="6" class="text-right">{{item.StudentNum}}</van-col>
                        <van-col span="6" class="text-right">{{item.RecruitNum}}</van-col>
                        <van-col span="6" class="text-right">{{item.JobPercentage}}</van-col>
                      </van-row>
                    </template>
                  </van-cell>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignUpFor",
  data() {
    return {
      isLoading: false,
      active: 0,
      SignUpForData: {} //报名数据
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.drawData();
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true
        });
      }, 500);
    },
    drawData() {
      this.apiSignUpGet(
        {
          WorkID: this.getWork().work.WorkID
        },
        this,
        e => {
          this.SignUpForData = e;
          //this.drawEchart(); //绘制图表
        }
      );
    }
  },
  created() {
    this.drawData();
  }
};
</script>

<style scoped>
</style>